import { Box, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from "@mui/material";
import { getAllSpecializationsReq } from "../../../../redux/guest-slices/common.slice";
import SkeletonImage from "../../../../components/ui/SkeletonImage";
import { FILE_PATH_URI } from "../../../../utils/helper";
import { Fragment, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

function Expertise({ expertise }) {
  const [specializations, setSpecializations] = useState([]);
  const dispatch = useDispatch();

  const getAllSpecializations = (filters) => {
    dispatch(
      getAllSpecializationsReq({
        limit: filters?.limit || 100,
      })
    )
      .unwrap()
      .then((data) => {
        setSpecializations(data || []);
      })
      .catch(() => { });
  };

  useEffect(() => {
    getAllSpecializations();
    // eslint-disable-next-line
  }, []);

  const specialization = specializations.find(
    (s) => s._id === expertise?.specializationId
  );

  return (
    <Fragment>
      <Typography sx={{ fontSize: "24px", fontWeight: "600" }}>
        User Expertise
      </Typography>
      <TableContainer className="specialistTable">
        <Table stickyHeader>
          <TableBody>
            <TableRow>
              <TableCell component="th">Specialization</TableCell>
              <TableCell>{specialization?.name}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                sx={{ whiteSpace: "normal !important" }}
                component="th"
              >Total Experience
              </TableCell>
              <TableCell>{expertise?.experience}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                sx={{ whiteSpace: "normal !important" }}
                component="th"
              >Certifications and Qualifications
              </TableCell>
              <TableCell sx={{ whiteSpace: "normal !important" }}>
                {expertise?.qualifications}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                sx={{ whiteSpace: "normal !important" }}
                component="th"
              >Certification Documents
              </TableCell>
              <TableCell>
                <Box
                  sx={{
                    borderRadius: 2,
                    overflow: "hidden",
                    aspectRatio: "1/1",
                    position: "relative",
                    display: "inline-block",
                    width: { xs: "initial", md: "250px" },
                  }}
                >
                  <SkeletonImage
                    src={FILE_PATH_URI + expertise?.certificate?.[0]?.path}
                  />
                </Box>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Fragment>
  );
}

export default Expertise;
